module.exports = __webpack_public_path__ + "static/media/icon-find-store.a12d4e53.png";